import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import VemigoTextFeild from 'src/components/VemigoGrid/VemigoTextFeild';
import { useStyles } from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { useCustomerBookingCart } from '../../selectedCustomerData';
import { useCustomerData } from '../../customerData';
import { ServicePriceServices } from 'src/services/price/servicePriceServices';
import VemigoSelectField from 'src/components/VemigoGrid/VemigoSelectTextFeild';
import { CustomerCartServicess } from 'src/services/customer/customerCartServices';

const tax = 0;

export const AddServiceBooking = (props) => {
  const { allServices, allCars, allTimeSlots } = useCustomerData();
  let description;
  const {
    refreshCartData,
    selectedCustomerData,
    handleGetCartData,
    cartCardsData,
    setCartCards,
    setCartId,
    CartId
  } = useCustomerBookingCart();

  const { open, handleClose, data, index, actionType, setActionType } = props;

  const dataModel = {
    id: 0,
    cartServiceId: 0,
    serviceId: 0,
    serviceName: '',
    serviceDescription: '',
    date: 0,
    timeSlotId: 0,
    timeSlot: '',
    note: '',
    price: 0,
    discountRate: 0,
    discountAmount: 0,
    taxRate: 0,
    taxAmount: 0,
    finalAmount: 0
  };

  const [newData, setNewData] = useState(dataModel);

  const { enqueueSnackbar } = useSnackbar();
  const [amount, setAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [amountDis, setAmountDis] = useState(0);
  const [amountTax, setAmountTax] = useState(0);
  const [discountFormula, setDiscountFormula] = useState('');
  const [selectedSlotId, setSelectedSlotId] = useState('');
  const [selectedServiceId, setSelectedServiceId] = useState('');

  useEffect(() => {
    if (actionType === 'EDIT') {
      setNewData({
        id: data.id,
        cartServiceId: data.cartServiceId,
        serviceId: data.serviceId,
        serviceName: data.serviceName,
        serviceDescription: data.serviceDescription,
        price: data.price,
        discountRate: data.discountRate,
        discountAmount: data.discountAmount,
        taxRate: data.taxRate,
        taxAmount: data.taxAmount,
        finalAmount: data.finalAmount,
        date: data.date,
        timeSlotId: data.timeSlotId,
        timeSlot: data.timeSlot,
        note: data.note ?? ''
      });
      setSelectedServiceId(data.serviceId);
      setSelectedSlotId(data.timeSlotId);
      setDiscount(
        parseFloat(((data.discountAmount * 100) / data.price).toFixed(2))
      );
      setAmount(data.finalAmount);
    } else if (actionType === 'DELETE') {
      if (CartId > 0 && cartCardsData[index].services.length === 1) {
        CustomerCartServicess.deleteData(CartId)
          .then((responseData) => {
            handleCloseUpdate();
            setCartId(0);
            const updatedServices = cartCardsData[index].services
              .filter((service) => service.id !== data.id)
              .map((service, serviceIndex) => ({
                ...service,
                id: serviceIndex + 1
              }));

            const updatedTotalAmount = updatedServices.reduce(
              (total, service) => total + service.finalAmount,
              0
            );

            const updatedTotalDiscount = updatedServices.reduce(
              (total, service) => {
                return total + parseFloat(service.discountAmaount || 0);
              },
              0
            );

            const updatedTotalTax = updatedServices.reduce((total, service) => {
              return total + parseFloat(service.taxAmaount || 0);
            }, 0);

            setCartCards((prevCartCards) => [
              ...prevCartCards.slice(0, index),
              {
                ...prevCartCards[index],
                services: updatedServices,
                totalAmount: updatedTotalAmount,
                totalDiscount: updatedTotalDiscount,
                totalTax: updatedTotalTax
              },
              ...prevCartCards.slice(index + 1)
            ]);
          })
          .catch((error) => {
            handleCloseUpdate();
            enqueueSnackbar(`Service can't be removed right now`, {
              variant: 'error'
            });
            console.error('Error updating data:', error);
          });
      } else {
        CustomerCartServicess.removeServiceFromCart(data.cartServiceId)
          .then((responseData) => {
            handleCloseUpdate();
            const updatedServices = cartCardsData[index].services
              .filter((service) => service.id !== data.id)
              .map((service, serviceIndex) => ({
                ...service,
                id: serviceIndex + 1
              }));

            const updatedTotalAmount = updatedServices.reduce(
              (total, service) => total + service.finalAmount,
              0
            );

            const updatedTotalDiscount = updatedServices.reduce(
              (total, service) => {
                return total + parseFloat(service.discountAmount || 0);
              },
              0
            );

            const updatedTotalTax = updatedServices.reduce((total, service) => {
              return total + parseFloat(service.taxAmount || 0);
            }, 0);

            setCartCards((prevCartCards) => [
              ...prevCartCards.slice(0, index),
              {
                ...prevCartCards[index],
                services: updatedServices,
                totalAmount: updatedTotalAmount,
                totalDiscount: updatedTotalDiscount,
                totalTax: updatedTotalTax
              },
              ...prevCartCards.slice(index + 1)
            ]);
            refreshCartData()
          })
          .catch((error) => {
            handleCloseUpdate();
            enqueueSnackbar(`Service can't be removed right now`, {
              variant: 'error'
            });
            console.error('Error updating data:', error);
          });
      }
    }
  }, [actionType === 'EDIT' || actionType === 'DELETE']);

  const handleCloseUpdate = () => {
    setNewData(dataModel);
    setSelectedServiceId('');
    setSelectedSlotId('');
    handleClose();
    setActionType('');
    setDiscount(0);
    setAmount(0);
  };

  const handleSelectChange = async (dataId) => {
    setSelectedServiceId(dataId);

    description = allServices.find((x) => x.id === dataId)?.shortDescription;

    const dataList =
      await ServicePriceServices.getAllServicePricesCityIdServiceIdCarcategoryId(
        selectedCustomerData.city.id,
        dataId,
        allCars.find((x) => x.id === cartCardsData[index].car.carId).carCategory
          .id
      );

    const amount = dataList[0]?.prices[0].amount ?? 0;
    const result = amount + (amount * tax) / 100;
    const taxAmount = (amount * tax) / 100;
    setAmount(result);
    setDiscount(0);
    setNewData({
      ...newData,
      id: cartCardsData[index].services.length + 1,
      serviceId: dataId,
      serviceName: allServices.find((x) => x.id === dataId).name,
      price: dataList[0]?.prices[0].amount ?? 0,
      finalAmount: result,
      taxRate: tax,
      taxAmount: taxAmount,
      serviceDescription: description
    });
  };

  const handleDataChange = (fieldName, value) => {
    if (fieldName === 'itemId') {
      setNewData({
        ...newData,
        serviceId: value,
        serviceName: allServices.find((x) => x.id === value).name
      });
    } else if (fieldName === 'timeSlotId') {
      setNewData({
        ...newData,
        [fieldName]: allTimeSlots.find((x) => x.id === value).id,
        timeSlot: `${allTimeSlots.find((x) => x.id === value).startTime} -
         ${allTimeSlots.find((x) => x.id === value).endTime}`
      });
    } else {
      setNewData({ ...newData, [fieldName]: value });
    }
  };

  const handleCalculatData = (fieldName, value) => {
    const price = newData.price;
    const formula = value[0];
    const number = parseFloat(value.replace(/[^\d.]/g, ''));
    let result;

    if (number) {
      if (formula === '%') {
        const discountAmount = (price * number) / 100;
        result = price - discountAmount;
        const taxAmount = (result * tax) / 100;
        result = parseFloat((result + taxAmount).toFixed(2));

        setDiscount(number);
        setAmount(result);
        setAmountDis(discountAmount);
        setDiscountFormula('');
        setAmountTax(taxAmount);
        setNewData((prevData) => ({
          ...prevData,
          price: price,
          discountRate: number,
          discountAmount: discountAmount,
          taxRate: tax,
          taxAmount: taxAmount,
          finalAmount: result
        }));
      } else if (formula === '+') {
        result = price + number;
        const taxAmount = (result * tax) / 100;
        result = parseFloat((result + taxAmount).toFixed(2));

        setDiscount(number);
        setAmount(result);
        setAmountDis(number);
        setDiscountFormula('add');
        setAmountTax(taxAmount);

        setNewData((prevData) => ({
          ...prevData,
          price: price,
          discountAmount: number,
          taxAmount: tax,
          finalAmount: result
        }));
      } else if (formula === '-') {
        result = price - number;
        const taxAmount = (result * tax) / 100;
        result = parseFloat((result + taxAmount).toFixed(2));

        setDiscount(number);
        setAmount(result);
        setAmountDis(number);
        setDiscountFormula('');
        setAmountDis(number);
        setAmountTax(taxAmount);

        setNewData((prevData) => ({
          ...prevData,
          price: price,
          discountAmount: number,
          taxAmount: tax,
          finalAmount: result
        }));
      }
    } else {
      result = price + (price * tax) / 100;
      setAmount(result);
      setDiscountFormula('');
      setDiscount(0);
      setNewData((prevData) => ({
        ...prevData,
        price: price,
        taxAmount: tax,
        discountAmount: 0,
        finalAmount: result
      }));
    }
  };

  const getFieldValue = (fieldId) => {
    if (fieldId.includes('.')) {
      const [parent, child] = fieldId.split('.');
      return newData[parent][child] || '';
    }
    return newData[fieldId] || '';
  };

  const handleAddNewData = () => {
    if (actionType === 'EDIT') {
      const dataToChange = {
        id: newData.cartServiceId,
        customerCarId: cartCardsData.find((x, cardIndex) => cardIndex === index)
          .car.customerCarId,
        customerAddressId: cartCardsData.find(
          (x, cardIndex) => cardIndex === index
        ).address.addressId,
        serviceId: newData.serviceId,
        date: newData.date,
        timeSlotId: newData.timeSlotId,
        price: newData.price,
        taxRate: newData.taxRate,
        taxAmount: newData.taxAmount,
        discountRate: newData.discountRate,
        discountAmount: newData.discountAmount,
        finalAmount: newData.finalAmount,
        note: newData.note
      };
      const updatedCartCards = cartCardsData.map((card, cardIndex) => {
        if (cardIndex === index) {
          const updatedServices = card.services.map((service) => {
            if (service.id === data.id) {
              return {
                ...service,
                serviceId: newData.serviceId,
                serviceName: newData.serviceName,
                description: newData.serviceDescription,
                date: newData.date,
                price: newData.price,
                taxRate: newData.taxRate,
                taxAmount: newData.taxAmount,
                discountRate: newData.discountRate,
                discountAmount: newData.discountAmount,
                finalAmount: newData.finalAmount,
                timeSlotId: newData.timeSlotId,
                timeSlot: newData.timeSlot,
                note: newData.note
              };
            } else {
              return service;
            }
          });

          const updatedTotalAmount = updatedServices.reduce(
            (total, service) => total + service.finalAmount,
            0
          );

          const updatedTotalDiscount = updatedServices.reduce(
            (total, service) => {
              return total + parseFloat(service.discountAmount || 0);
            },
            0
          );

          const updatedTotalTax = updatedServices.reduce((total, service) => {
            return total + parseFloat(service.taxAmount || 0);
          }, 0);

          return {
            ...card,
            services: updatedServices,
            totalAmount: updatedTotalAmount,
            totalDiscount: updatedTotalDiscount,
            totalTax: updatedTotalTax
          };
        } else {
          return card;
        }
      });

      CustomerCartServicess.updateCartServices(dataToChange)
        .then((responseData) => {
          setCartCards(updatedCartCards);
        })
        .catch((error) => {
          handleCloseUpdate();
          enqueueSnackbar(`Not able to update`, {
            variant: 'error'
          });
          console.error('Error updating data:', error);
        });
    } else {
      if (!selectedServiceId || !selectedSlotId || !newData.date) {
        enqueueSnackbar('Please fill in all mandatory fields', {
          variant: 'error'
        });
        return;
      } else if (!newData.price) {
        enqueueSnackbar(
          `Please update the price for "${newData.serviceName}"`,
          {
            variant: 'error'
          }
        );
        return;
      }

      if (CartId === 0) {
        const reqModel = {
          id: 0,
          customerId: selectedCustomerData.id,
          cartServices: [
            {
              id: 0,
              customerCarId: cartCardsData[index].car.customerCarId,
              customerAddressId: cartCardsData[index].address.addressId,
              serviceId: newData.serviceId,
              date: newData.date,
              timeSlotId: newData.timeSlotId,
              price: newData.price,
              taxRate: newData.taxRate,
              taxAmount: newData.taxAmount,
              discountRate: newData.discountRate,
              discountAmount: newData.discountAmount,
              finalAmount: newData.finalAmount,
              note: newData.note
            }
          ],
          lastUpdated: '2024-03-16T11:54:31.978Z',
          createdById: 0,
          note: 'string',
          cartType: 0
        };
        CustomerCartServicess.addNewCartData(reqModel)
          .then(() => {
            handleCloseUpdate();
            refreshCartData()
          })
          .catch(() => {
            handleCloseUpdate();
            enqueueSnackbar('services is not added', {
              variant: 'error'
            });
          });
      } else {
        const reqModel = {
          customerCarId: cartCardsData[index].car.customerCarId,
          customerAddressId: cartCardsData[index].address.addressId,
          serviceId: newData.serviceId,
          date: newData.date,
          timeSlotId: newData.timeSlotId,
          price: newData.price,
          taxRate: newData.taxRate,
          taxAmount: newData.taxAmount,
          discountRate: newData.discountRate,
          discountAmount: newData.discountAmount,
          finalAmount: newData.finalAmount,
          note: newData.note
        };

        CustomerCartServicess.addServiceToCart(CartId, reqModel)
          .then((data) => {
            setCartCards(prevCartCards => {
              return prevCartCards.map((card, cardIndex) => {
                if (cardIndex === index) {
                  const addData = {
                    ...newData,
                    cartServiceId: data?.id
                  };

                  return {
                    ...card,
                    services: [...card.services, addData],
                    totalAmount: card.totalAmount + newData.finalAmount,
                    totalTax: card.totalTax + newData.taxAmount,
                    totalDiscount: discountFormula
                      ? card.totalDiscount - newData.discountAmount
                      : card.totalDiscount + newData.discountAmount
                  };
                }
                return card;
              });
            });

            handleCloseUpdate();
            refreshCartData()
          })
          .catch((error) => {
            handleCloseUpdate();
            throw error;
          });
      }
    }
    handleCloseUpdate();
  };

  const allFields = [
    {
      id: 'itemId',
      field: 'Select',
      title: 'Service Name *',
      type: 'Search',
      selectedId: selectedServiceId,
      dataList: allServices,
      function: handleSelectChange,
      size: 12
    },
    {
      id: 'description',
      field: 'description',
      title: 'Description',
      type: 'text',
      multiline: true,
      size: 12
    },
    {
      id: 'price',
      value: newData.price,
      field: 'tField',
      title: 'Price',
      type: 'text',
      size: 3
    },
    {
      id: 'discountAmount',
      value: discount,
      field: 'SelectTextFields',
      symbols: ['%', '+₹', '-₹'],
      title: 'Discount',
      type: 'text',
      size: 3
    },
    {
      id: 'taxAmount',
      value: tax,
      symbol: '%',
      field: 'tField',
      title: 'Tax',
      type: 'text',
      size: 3
    },
    {
      id: 'finalAmount',
      value: amount,
      field: 'tField',
      title: 'Amount',
      type: 'text',
      size: 3
    },
    {
      id: 'date',
      field: 'dateField',
      title: 'Select Date *',
      type: 'date',
      size: 6
    },
    {
      id: 'timeSlotId',
      field: 'Select',
      title: 'Select Time Slot *',
      type: 'Search',
      selectedId: selectedSlotId,
      dataList: allTimeSlots,
      function: setSelectedSlotId,
      size: 6
    },
    {
      id: 'note',
      field: 'textField',
      title: 'Note',
      type: 'amet, consectetur adipiscing elit.',
      multiline: true,
      counter: true,
      maxChars: 250,
      size: 12
    }
  ];

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle style={useStyles.dialogTitle}>Add Service</DialogTitle>
      <DialogContent style={useStyles.bodyStyle}>
        <Grid container spacing={4} style={useStyles.boxSize}>
          {allFields.map((field) => (
            <Grid item xs={field.size} key={field.id}>
              <Typography style={useStyles.formTitle}>{field.title}</Typography>
              {field.field === 'textField' && (
                <VemigoTextFeild
                  style={useStyles.formControl}
                  id={field.id}
                  type={field.type}
                  fullWidth
                  multiline={field.multiline}
                  autoFocus={false}
                  counter={field.counter || false}
                  maxChars={field.maxChars}
                  value={getFieldValue(field.id) || ''}
                  onChange={(e) => handleDataChange(field.id, e.target.value)}
                  key={`textfield-${field.id}`}
                />
              )}
              {field.field === 'dateField' && (
                <TextField
                  style={useStyles.formControl}
                  id={field.id}
                  type={field.type}
                  fullWidth
                  multiline={field.multiline}
                  value={getFieldValue(field.id) || ''}
                  onChange={(e) => handleDataChange(field.id, e.target.value)}
                  key={`textfield-${field.id}`}
                />
              )}
              {field.field === 'tField' && (
                <input
                  style={{
                    width: '90px',
                    backgroundColor: 'transparent',
                    padding: '13px 15px',
                    borderRadius: '9px',
                    height: '50px',
                    border: 'solid 1px #ccc',
                    textAlign: 'right',
                    fontSize: '15px',
                    overflow: 'hidden'
                  }}
                  value={
                    field.symbol
                      ? `${field.value} ${field.symbol}`
                      : field.value
                  }
                  readOnly
                />
              )}
              {field.field === 'description' && (
                <div
                  style={{
                    background: '#DDDDDD',
                    minHeight: '40px',
                    width: '100%',
                    padding: '15px',
                    borderRadius: '9px'
                  }}
                >
                  <Typography>{newData.serviceDescription}</Typography>
                </div>
              )}
              {field.field === 'SelectTextFields' && (
                <VemigoSelectField
                  value={field.value}
                  min={newData.price}
                  options={field.symbols}
                  onChange={(value) => {
                    handleCalculatData(field.id, value);
                  }}
                />
              )}
              {field.field === 'Select' && (
                <Select
                  displayEmpty
                  style={useStyles.formControl}
                  fullWidth
                  value={field.selectedId}
                  onChange={(e) => {
                    handleDataChange(field.id, e.target.value);
                    field.function(e.target.value);
                  }}
                >
                  <MenuItem value="" disabled key={`${field.id}-empty`}>
                    <em>{field.type}</em>
                  </MenuItem>
                  {field.dataList.map((data) => (
                    <MenuItem key={data?.id} value={data?.id}>
                      {field.id === 'timeSlotId'
                        ? `${data?.startTime} - ${data?.endTime}`
                        : data?.name}
                    </MenuItem>
                  ))}
                </Select>
              )}
              {field.field === 'EmptyGrid' && (
                <Grid item xs={field.size} key={field.id} />
              )}
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleCloseUpdate}
          variant="contained"
        >
          Cancel
        </Button>
        <Button
          onClick={handleAddNewData}
          color="primary"
          variant="contained"
        >
          Add Service
        </Button>
      </DialogActions>
    </Dialog>
  );
};
